import { useEffect } from 'react';
import { setStorageIsSetuSharingSuccess, setStorageIsSetuSharingAbort } from '../utils';

export const useSetuRedirect = () => {
  const url = window.location.href;

  useEffect(() => {
    const handleReferral = () => {
      const consentUrlLastIndexOf = url.lastIndexOf('id=');
      const isUserAbort = url.includes('success=false');
      const isUserConfirm = url.includes('success=true');

      if (consentUrlLastIndexOf !== -1) {
        if (url && isUserConfirm) {
          setStorageIsSetuSharingSuccess('true');
        }

        if (url && isUserAbort) {
          setStorageIsSetuSharingAbort('true');
        }
      }
    };

    handleReferral();
  }, []);
};
